import React, { Component } from 'react';
import { Link } from "react-router-dom";
import { connect } from "react-redux"
import Moment from 'react-moment'
import moment from 'moment'

import Modal from 'react-responsive-modal';
import classNames from 'classnames';

import agent from '../agent'
import Aux from './AuxContainer'
import BasicInfo from '../components/BasicInfo'
import BasicInfoBottom from '../components/BasicInfoBottom'
import TestForm from '../components/profile/TestForm'
import UpdateProfile from '../containers/UpdateProfile'
import ProjectList from '../components/ProjectList'
import DashboardAvatar from '../components/DashboardAvatar'
//import ProfileForm from '../components/profile/ProfileForm'
import General from '../components/profile/General'
import artistType from '../data/artist-type';
import Back from '../components/Back'
import AMLogo from '../assets/images/audition-magic-favicon.png'
import { Field, reduxForm } from 'redux-form'
import { store, history } from '../store/configureStore'
import ImDb from '../components/ImDb';

import filter from 'lodash/filter'
import concat from 'lodash/concat'


//<Header {...location.state} artistInfo={artistInfo} fromRegistration={fromRegistration}/>

const Header = ({clientDetails, artistInfo, fromRegistration}) => {
	
	if (clientDetails && clientDetails.projectId) {
		return (
			<section id="brand-logo" className="section-brand-logo dashboard-header section">
			  <div className="row text-center">
				  <div className="small-12 medium-4 medium-offset-4 column">
				  	<div className="header-image-container">
					  	<img className="project-logo" src={clientDetails.projectId.cover_url} alt="" />
				  	</div>
				  </div>
				  <div className="small-12 medium-4 column">
				  	<div className="header-image-container">
					  	<img className="company-logo" src={clientDetails.client.logo_url} alt="" />
				  	</div>
				  </div>
				</div>

			  <div className="row">
				  <div className="small-12 small-centered column text-center with-name post-relative">
				  	<Back />
				    <h2>Welcome { !fromRegistration && "back" } {artistInfo.first_name}</h2>
				    <p className="top-title">Please check your details below before we proceed</p>
				  </div>
			  </div>
			</section>
		)
	}
	return (
		<section id="brand-logo" className="section-brand-logo dashboard-header section">
		  <div className="row">
		  <div className="small-12 small-centered column text-center">
		  	<div className="header-image-container">
			  	<img className="am-logo" src={AMLogo} alt=""/>
		  	</div>
		  	<div className="post-relative with-name">
		  		<Back />
			  	{artistInfo && <h2>Welcome { !fromRegistration && "back" } {artistInfo.first_name}</h2>}
			    <p className="top-title">Please check your details below before we proceed</p>
		    </div>
		  </div>
		  </div>
		</section>
	)
}

class ArtistDashboardContainer extends Component {
	state = {
		projectId: new URLSearchParams(this.props.location.search).get('project'),
		pathname: '/artist/projects',
		showModal: false,
		errorModalTitle: 'Restricted from Proceeding',
		enableButton: false,
		showModal_info: false,
    showModal_reg: false,
		dashboard: 'dashboard-selected',
		projects: 'projects',
		profile: 'profile',
		general: 'general',
		dashboardCl: 'tabs-panel tab-panel-fix is-active',
		profileCl: 'tabs-panel tab-panel-fix',
		projectsCl: 'tabs-panel tab-panel-fix',
		generalCl: 'tabs-panel tab-panel-fix',
		showMenu: false,
		artistInfo: null,
		disableButton: false,
		dash_menu: false,
		flagForClient: false,
		role_list: [],
    loading: true,
    project: null,
    artistRestricted: false,
    messaging: ''
	}

	componentDidMount() {
  	this.handleStateVariables();
  }

  async handleStateVariables() {
  	const { location } = this.props;
  	const publicToken = new URLSearchParams(location.search).get('token');
  	var project_id = new URLSearchParams(location.search).get('project');;
  	console.log('componentWillMount-dashboard', this.props)
  	const flag = ((typeof this.props.location.state !== 'undefined') && (typeof this.props.location.state.flag !== 'undefined')) ? this.props.location.state.flag : false
  	//const flagForClient = client.meta.audition[0].artist_id === artistInfo.id;	//client.meta.audition.find(l => l.artist_id === artistInfo.id)
  	//const auditions = this.props.client.meta;

    let artist_storage = null
    try {
    	artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))
    } catch (parseError) {
    	window.appsignal.send({error: parseError, description: 'Parse error at Artist Dashboard while loading variables'})
    }

    const artistInfo = artist_storage ? artist_storage.artist : null

    let project = null

    if (publicToken) {
      project = await agent.Project.viaToken(publicToken)
      project = project.project
    } else if (project_id) {
      project = await agent.Project.projectById(project_id)
      project = project.project
    }


    if (project_id) {
      this.setCheckinLink();
    }

    if (project && artistInfo){
      this.props.onLoad(
        agent.Client.checkProjectArtist(project.id, artistInfo.id)).then(() => { 
            this.setState({enableButton: true}) }) 
      this.setState({ project: project, projectId: project.id })
    }

    this.setState({ artistInfo: artistInfo })

  	if (flag) {
  		this.setState({ 
  			projects: 'projects-selected', 
  			dashboard: 'dashboard',
  			projectsCl: 'tabs-panel tab-panel-fix is-active',
  			dashboardCl: 'tabs-panel tab-panel-fix'
  		})
  	}
  	if (this.props.auditions) {
	  	const x = this.props.auditions.find(k => k.artist_id === this.props.artists[0].id)
	  	this.setState({ flagForClient: x.length >= 1 })
	}
  	//let artist = this.props.artist || artistInfo;
  	let artist = ''
  	if (artistInfo) {
	  	if (artistInfo.birth_date) {
	  		let age = moment(artistInfo.birth_date).format('YYYY')
	  		age = moment().format('YYYY') - age
	  		age = parseInt(moment(artistInfo.birth_date).format('MM')) >= parseInt(moment().format('MM')) ?
	  			  parseInt(moment().format('DD')) < parseInt(moment(artistInfo.birth_date).format('DD')) ? parseInt(age) - 1 : age : age
	  		if (age >= 18) { artist = { ...artistInfo, ageCategory: 'adult' } }
	  		else { artist = { ...artistInfo, ageCategory: 'minor' } }
	  		this.setState({ artistInfo: artist })
	  		// console.log('sample', artistInfo)
	  	} else {
	  		if ((artistInfo.age_from !== null && artistInfo.age_to !== null) || !artistInfo.is_minor) {
	  			artist = { ...artistInfo, ageCategory: 'adult' }
	  			this.setState({ artistInfo: artist })
	  			// console.log('Im adult')
	  		} else if (artistInfo.is_minor){
          artist = { ...artistInfo, ageCategory: 'minor' }
          this.setState({ artistInfo: artist })
	  		}
	  	}
	}
  	this.props.setCurrentArtist(artistInfo)
  	
    if (project_id) {
    	const rolesss = agent.Project.getRoles(project.id).then((k) => {
    		this.setState({
    			role_list: k.roles
    		})
    	})
    }
  	
    this.setState({loading: false})

    // Restrict artist
    let artistRestricted = false;
    let messaging = 'Sorry you are not listed in the schedule for this audition please speak to the person in charge of casting.';

    // Check evaluation for project
    if (project && project.location_restrictions && artistInfo) {
      let locRest = project.location_restrictions;
      locRest = locRest.split(',');
      artistRestricted = (artistInfo.state && (locRest.indexOf(artistInfo.state) > -1)) || (artistInfo.country && (locRest.indexOf(artistInfo.country) > -1))

      if (!artistRestricted) {
        messaging = 'Sorry, your location of origin is currently not part of the list of locations the organizers set up. Please contact the organizers to have yourself considered.';
      }
      
      if (project.public_skip_agency) {
        artistRestricted = artistRestricted && (artistInfo.artist_type == 'freelance');
        if (artistInfo.artist_type != 'freelance') {
          messaging = 'Sorry, your representation type prevents you from applying to this project. Please contact the organizers to have yourself considered.';
        }
      }

      artistRestricted = !artistRestricted;

    }
    // Show modal
    let showModalReg = (artistInfo != null) && (artistInfo.email != null) && (publicToken != null) && (project != null) && !artistRestricted

    this.setState({ showModal_reg: showModalReg, messaging: messaging, artistRestricted: artistRestricted });
    
    // Check if there are available roles for the artist
    try {
    	if (artistInfo != null && project_id) {
		    let roles = await agent.Project.getRolesForArtist(project_id, artistInfo.id);
		    roles = roles.roles;
		    console.log('Roles available', roles);
		    if ( roles == null || roles.length == 0 ) {
		    	this.setState({ showModal: true, 
		    		messaging: "Sorry currently the roles for this project don’t match your gender and/or age-range of your profile.", 
		    		errorModalTitle: "ROLES NOT SUITABLE", 
		    		artistRestricted: true });
		    }
		    
	    } 
	  } catch (error)	{
	    	window.appsignal.sendError(error);
	  }
    
  }

  profile_refresh = (trigger) => {
  	if (trigger){
  		const { location } = this.props;
	  	const publicToken = new URLSearchParams(location.search).get('token');

	  	if(location.state && location.state.artist) {
	  		this.props.setCurrentArtist(location.state.artist)
	  	}
	  	if (this.state.projectId && location.state.artist) {
	  		this.setCheckinLink();
	  		// this.props.onLoad(agent.Client.checkProjectArtist(this.state.projectId, location.state.artist.id))
	  		// 	.then(({ result }) => { this.setState({enableButton: true}) })
	  		this.props.onLoad(agent.Client.checkProjectArtist(this.state.projectId, location.state.artist.id))
	  			.then(() => { this.setState({enableButton: true}) })
	  	}

	  	if (publicToken) {
	  		this.props.onLoad(agent.Client.checkProjectArtist(location.state.clientDetails.projectId.id, location.state.artist.id))
	  			.then(() => { this.setState({enableButton: true}) })
	  	}
  	} else {
      // Check if global artist exists
      try {
	    	let current_artist = window.localStorage.getItem('artist_jwt')
	      this.props.setCurrentArtist(JSON.parse(current_artist).artist)
	      this.setState({ artistInfo: JSON.parse(current_artist).artist })
	    } catch (parseError) {
	    	window.appsignal.send({error: parseError, description: 'Parse error at Artist Dashboard when checking global artist'})
	    }
      
    }
  }

  updateBasicInfo = (values) => {
  	//const statJson = JSON.parse(values.artist.statistics);
  	//values.artist.statistics = statJson
  	console.log('updateBasicInfo', values)
  	this.props.updateDetails(this.props.artistInfo.id, values).then((k) => {
  		this.setState({ showModal_info: true })
  	});
  }

  setCheckinLink = () => {
  	const { projectId } = this.state
		if (projectId) {
			this.setState({
				pathname: `/projects/checkin/${projectId}`
			})	
		}
	}

  onOpenRepresentation = () => {
    this.changePage("profile")
  }

	onOpenModal = () => {
    this.setState({ showModal: true });
  }
  
  onCloseModal = () => {
    this.setState({ showModal: false });
  }
  onCloseModal_info = () => {
    this.setState({ showModal_info: false });
    // const publicToken = new URLSearchParams(this.props.location.search).get('token')
    // this.props.logoutAritst()
    // if (publicToken) {
	   //  history.push({
	   //    pathname: '/public_registration',
	   //    search: this.props.location.search,
	   //    state: this.props.location.state
	   //  })
    // } else {
    // 	history.push({
	   //    pathname: '/',
	   //    search: this.props.location.search,
	   //    state: this.props.location.state
	   //  })
    // }
  }
  onCloseModal_reg = () => {
    this.setState({ showModal_reg: false });
  }


  filteredRoles = (roles) => {
		const publicToken = new URLSearchParams(this.props.location.search).get('token');
		const { gender, age_from, age_to, birth_date } = this.state.artistInfo

		if (roles) {

	  	const rolesForBothGender = filter(roles, {'gender': 'both'})
	  	const rolesForArtistGender = filter(roles, {'gender': gender })
	  	let age;

	  	if (birth_date) {
	  		age = moment().diff(birth_date, 'years') // ?? null	
	  	} else {
	  		age = Math.abs(age_from - age_to)
	  	}
	  	

	  	let filteredRolesByAge = new Array()

	  	const filteredGenderRoles = rolesForBothGender.concat(rolesForArtistGender)
	  	filteredGenderRoles.forEach(role => {
				if (!birth_date) {
					
					if ((age_from >= role.age_from && age_from <= role.age_to) || (age_to <= role.age_to) ) {
						filteredRolesByAge.push(role)
					}

					// if (age_from >= role.age_from && age_to <= role.age_to) {
					// 	filteredRolesByAge.push(role)
					// }
				} else {
		      if (age >= role.age_from && age <= role.age_to ||
		        age <= role.age_from && age >= role.age_to) {
		        // filteredRolesByAge.addObject(role);
		      	filteredRolesByAge.push(role)
		      } 
	      }
	    });

	  	// filteredRolesByAge = filter(filteredRolesByAge, {'opportunity': null})
	  	if (publicToken) {
	  		filteredRolesByAge = filter(filteredRolesByAge, {'public_registration': true})	
	  	} else {
	  		filteredRolesByAge = filter(filteredRolesByAge, {'checkin_enabled': true})
	  	}
	  	
			return filteredRolesByAge
		}

		return [];
  }

  changePage = (value) => {
   this.setState({
   	dashboard: value === 'dashboard' ? 'dashboard-selected' : 'dashboard',
   	profile: value === 'profile' ? 'profile-selected' : 'profile',
   	projects: value === 'projects' ? 'projects-selected' : 'projects',
   	general: value === 'general' ? 'general-selected' : 'general',
   	dashboardCl: value === 'dashboard' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
   	profileCl: value === 'profile' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
   	projectsCl: value === 'projects' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix',
   	generalCl: value === 'general' ? 'tabs-panel tab-panel-fix is-active' : 'tabs-panel tab-panel-fix'
   })
   
   if (value === 'dashboard') {
	   this.handleStateVariables();
   }
   // if (value === 'projects') {
	  //  history.push({
	  //     pathname: '/artist/dashboard/projects',
	  //     search: this.props.location.search,
	  //     state: this.props.location.state
	  //  })
   // }
  }

  showMenu = () => {
  	this.setState({ showMenu: this.state.showMenu ? false : true })
  }

  handleViewGeneral = () => {
  	this.setState({
  		dashboard: 'dashboard',
  		general: 'general-selected',
  		dashboardCl: 'tabs-panel tab-panel-fix',
  		generalCl: 'tabs-panel tab-panel-fix is-active'
  	})
  }

  showDashMenu = () => {
  	this.setState({
  		dash_menu: !this.state.dash_menu
  	})
  }

  handleViewProfile = () => {
  	this.setState({
  		dashboard: 'dashboard',
  		profile: 'profile-selected',
  		dashboardCl: 'tabs-panel tab-panel-fix',
  		profileCl: 'tabs-panel tab-panel-fix is-active'
  	})
  }

  submit = (values, dispatch, props) => {
  	this.setState({ disableButton: true })
  	let params = {
  		artist: {
  			first_name: values.artist.first_name,
  			last_name: values.artist.last_name,
  			mobile_number: values.artist.mobile_number,
  			email: values.artist.email,
  			artist_type: values.artist.artist_type,
  			gender: values.artist.gender,
  			category: values.artist.category,
  			state: values.artist.state,
  			country: values.artist.country,
  			union: values.artist.hasUnion,
  			union_id: values.artist.union_id,
  			id: values.artist.id,
        age_from: values.artist.age_from,
        age_to: values.artist.age_to,
        is_minor: values.artist.ageCategory === 'minor'

  		}
  	}
  	
  	const getFormData = (object, namespace) => Object.keys(object).reduce((formData, key) => {	
  		let formKey = namespace ? `${namespace}[${key}]` : key
  		if (key == 'statistics') {
  			let val = Object.keys(object[key]).reduce((innerFormData, key2) => {
  					let formKey2 = `${namespace}[${key}][${key2}]`
  					formData.append(formKey2, object[key][key2])
  					return innerFormData
  				}, new FormData());
  		} else {
  			formData.append(formKey, object[key])
  		}
  		return formData
    }, new FormData());

    let that = this
  	agent.Artist.updateProfile(params.artist.id, getFormData(params.artist, 'artist')).then((k) => {
      window.localStorage.removeItem('artist_jwt')
      window.localStorage.setItem('artist_jwt', JSON.stringify(k))
      that.profile_refresh()
  	  //that.setState({ showModal_info: true, disableButton: false })
    });
  }

	render() {
		const hidDiv = {
			display: 'none'
		};
		const span1 = {
			paddingRight: '0',
			paddingTop: '0.7rem'
		}
		const span2 = {
			paddingLeft: '0',
			color: '#000'
		}
		const marginOut = {
			marginTop: '0'
		}
		const maxOut = {
			width: '100%'
		}
		const sectionFix = {
			maxWidth: 'none',
			padding: window.innerWidth < 400 ? '0 1rem 0 1rem' : '0 4rem 0 4rem'
		}
		const { location, client, fromRegistration, roles, publicArtist } = this.props
		const { projectId, loading, project, artistRestricted, messaging } = this.state
		const publicToken = new URLSearchParams(location.search).get('token');
		const imdb = new URLSearchParams(this.props.location.search).get('imdb')
		var cleanRoles = []
		const labels = {
			label: 'I am a'
		}
    let artist_storage = null
    try {
    	artist_storage = JSON.parse(window.localStorage.getItem('artist_jwt'))
    } catch (parseError) {
    	window.appsignal.send({error: parseError, description: 'Parse error at Artist Dashboard'})
    }

    let artistInfo = artist_storage ? artist_storage.artist : this.state.artistInfo

    if ( loading ) {
      return (
        <Aux>
        <Header />
        <section className="gray-bg section">
          <p className="text-center loading-text">Loading...</p>
        </section>
        </Aux>
      )
    }

    let header_url = '/artist/dashboard'

    if (publicToken != null) {
      header_url = `${header_url}?token=${publicToken}`
    }

		//check roles list
		//cleanRoles = roles != null ? roles : publicArtist.roles;
		if (typeof(roles) != "undefined"){
			cleanRoles = roles
			console.log('checking-roles true', cleanRoles)
		}
		else if (typeof(publicArtist) != 'undefined') {
			cleanRoles = publicArtist.roles
			console.log('checking-roles false', cleanRoles)
		}
		// filter roles
		if (projectId && client.meta && !client.meta.has_audition) {
			client.roles = this.filteredRoles(client.roles);	
		}
		// console.log('>>dashboard', this.props)
		// console.log('>>dashboard state', this.state)

		if ( (!artistInfo || !client.project) && projectId ) {
			return (
				<Aux>
				<Header />
				<section className="gray-bg section">
					<p className="text-center loading-text">Loading...</p>
				</section>
				</Aux>
			)
		}

    

    // filter roles
		if ((projectId && client.meta && !client.meta.has_audition) || publicToken ) {
			client.roles = this.filteredRoles(client.roles);	
		}
		console.log('dashboard-1', this.props, window.innerWidth, window.innerWidth < 700)
		return (
			<div style={maxOut}>
				{ imdb && (<ImDb />) }
				<div className="top-bar">
				  <div className="top-bar-left top-bar-left-fix">
				    <ul className="dropdown menu" data-dropdown-menu>
				      <li className="menu-text">
				      	<a className="home" href={header_url}>
				      		<div className="navbar-header logo"></div>
						</a>
					  </li>
				    </ul>
				  </div>
				  <div className="top-bar-right top-bar-right-fix">
				    <ul style={marginOut} className="menu right-nav">
				      <li><div className="user-info">
						<button onClick={this.showMenu}>
							<h1>{artistInfo.first_name} {artistInfo.last_name}</h1>
							<img src={artistInfo.photo || artistInfo.photo_thumb} />
							<span>
								<i className="fa fa-caret-down" />
							</span>
						</button>
						{
							this.state.showMenu &&
								(<div className="row small-12 logout-menu">
									<i style={span1} className="column small-6 fa fa-sign-out"></i>
									<a style={span2} className="column small-6 end" onClick={this.props.logoutAritst}>Log-out</a>
								</div>)
						}
					</div></li>
				    </ul>
				  </div>
				</div>

				<span style={hidDiv} className="logout-btn fa-stack fa-1x" onClick={this.props.logoutAritst} >
				  <i className="fa fa-circle fa-stack-2x icon-background"></i>
				  <i className="fa fa-sign-out fa-stack-1x"></i>
				</span>

				<section>
					<nav className="action-nav">
					{
						window.innerWidth < 400 ?
						(<ul className="dropdown menu" data-dropdown-menu>
					  		<li>
					    		<a onClick={this.showDashMenu} className="fa fa-bars fa-3" aria-hidden="true"></a>
					    		{
					    			this.state.dash_menu &&
					    			(<ul className="action-nav tabs" data-tabs id="agency-selection-tabs">
					              <li className="column small-12 tabs-title dash-hover is-active">
					              	<a id="dash" onClick={e => this.changePage("dashboard")} aria-selected={this.state.dashboard == 'dashboard-selected'}>
					              		<div className={this.state.dashboard}></div>DASHBOARD
					              	</a>
					              </li>
					              <li className="column small-12 tabs-title gen-hover">
					              	<a id="gen" onClick={e => this.changePage("general")} aria-selected={this.state.general == 'general-selected'}>
					              		<div className={this.state.general}></div>GENERAL
					              	</a>
					              </li>
					              <li className="column small-12 tabs-title prof-hover">
					              	<a id="prof" onClick={e => this.changePage("profile")} aria-selected={this.state.profile == 'profile-selected'}>
					              		<div className={this.state.profile}></div>PROFILE
					              	</a>
					              </li>
					              <li className="column small-12 tabs-title proj-hover">
					              	<a id="proj" onClick={e => this.changePage("projects")} aria-selected={this.state.projects == 'projects-selected'}>
					              		<div className={this.state.projects}></div>PROJECTS
					              	</a>
					              </li>
					            	</ul>)
					        	}
					    	</li>
					    </ul>) :
						(<ul className="action-nav tabs" data-tabs id="agency-selection-tabs">
			              <li className="tabs-title dash-hover is-active">
			              	<a id="dash" onClick={e => this.changePage("dashboard")} aria-selected={this.state.dashboard == 'dashboard-selected'}>
			              		<div className={this.state.dashboard}></div>DASHBOARD
			              	</a>
			              </li>
			              <li className="tabs-title gen-hover">
			              	<a id="gen" onClick={e => this.changePage("general")} aria-selected={this.state.general == 'general-selected'}>
			              		<div className={this.state.general}></div>GENERAL
			              	</a>
			              </li>
			              <li className="tabs-title prof-hover">
			              	<a id="prof" onClick={e => this.changePage("profile")} aria-selected={this.state.profile == 'profile-selected'}>
			              		<div className={this.state.profile}></div>PROFILE
			              	</a>
			              </li>
			              <li className="tabs-title proj-hover">
			              	<a id="proj" onClick={e => this.changePage("projects")} aria-selected={this.state.projects == 'projects-selected'}>
			              		<div className={this.state.projects}></div>PROJECTS
			              	</a>
			              </li>
			            </ul>)
			        }
					</nav>
					{
					/*<ul className="dropdown menu" data-dropdown-menu>
					  <li>
					    <a onClick={this.showDashMenu} className="fa fa-bars" aria-hidden="true"></a>
					    {
					    	this.state.dash_menu && window.innerWidth < 700 &&
						    (<ul className="menu">
						      <li><a href="#">Item 1A</a></li>
						    </ul>)
					    }
					  </li>
					</ul>*/
					}
				</section>

				<div className="tabs-content tabs-content-fix" data-tabs-content="agency-selection-tabs">
					<div className={this.state.dashboardCl}>
					{
							this.state.dashboard == 'dashboard-selected' &&
						(<div><section id="artist-dashboard" className="section-artist-dashboard gray-bg section">
							{
								// (client.message || (client.meta && !client.meta.has_audition && !client.project.allow_new_artist_checkin))
								// ? publicToken ?
								// <div className="row">
								// 	<div className="small-12 small-centered column">
								// 		<div className="text-center">
								// 			<p className="text-center">You have already been submitted to this project.</p>
								// 		</div>
								// 	</div>
								// </div> : 
								// <div className="row">
								// 	<div className="small-12 small-centered column">
								// 		<div className="text-center">
								// 			<p className="text-center">You have already checkin.</p>
								// 		</div>
								// 	</div>
								// </div>
								// :
								// <p></p>
								//condition for this below on submit myself // publicToken && client.project
							}
							<div style={sectionFix} className="row">
							<div className="small-12 small-centered column">
								<BasicInfo 
									onSubmit={this.updateBasicInfo}
									onViewProfile={this.handleViewGeneral} 
									projectId={projectId}
    							moveToRepresentation={this.onOpenRepresentation}
									artistPhoto={artistInfo.photo || artistInfo.photo_thumb}/>
							</div>
							</div>
						</section>
						<section id="artist-dashboard" className="section-artist-dashboard lightgray-bg section">
							<div style={sectionFix} className="row">
							<div className="small-12 small-centered column">
								<BasicInfoBottom 
									onSubmit={this.updateBasicInfo} 
									projectId={projectId}
									showModal_info={this.state.showModal_info}
									artistInfo={artistInfo}
									artistPhoto={artistInfo.photo || artistInfo.photo_thumb}/>
							</div>
							</div>
						</section></div>)
					}
					</div>
					<div className={this.state.profileCl}>
					{
						this.state.profile == 'profile-selected' &&
						(<section>
							<UpdateProfile artistInfo={this.state.artistInfo} profileRefresh={this.profile_refresh} />
						</section>)
					}
					</div>
					<div className={this.state.projectsCl}>
					{
						this.state.projects == 'projects-selected' &&
						(<section>
							<ProjectList artistInfo={artistInfo} roles={cleanRoles}
								 />
						</section>)
					}
					</div>
					<div className={this.state.generalCl}>
					{
						this.state.general == 'general-selected' &&
						(<section>
							<General artistInfo={this.state.artistInfo} artistType={artistType} 
							onSubmit={this.submit} disableButton={this.state.disableButton} 
							ageCategory={this.state.artistInfo.ageCategory} labels={labels}
              moveToRepresentation={this.onOpenRepresentation} />
							</section>)
					}
					</div>
				</div>

				<section id="user-info-summary" style={hidDiv} className="section-user-info-summary lightgray-bg section">
					<div className="row">
					<div className="small-12 small-centered column">
						{
						// <p>
						// 	<i className="fa fa-star"></i> 
						// 	<span> Full Member Since:</span>
						// 	<span> <Moment format="MMMM YYYY">{artistInfo.created_at}</Moment>on a premium package</span>
						// 	{ !projectId && <Link to="/"> Change</Link> }
						// </p>

						// <p>
						// 	<i className="fa fa-star"></i> 
						// 	<span> Profile Created: </span>
						// 	<span>By you, Lumo project, Jaanuary 2016</span>
						// </p>

						// <p>
						// 	<i className="fa fa-star"></i> 
						// 	<span> Last Updated to Profile: </span>
						// 	<span>25th May 2017 3:00am EST </span>
						// 	{ !projectId && <Link to="/">Update</Link>}
						// </p>

						// <p>
						// 	<i className="fa fa-star"></i> 
						// 	<span> Profile Include: </span>
						// 	<span>5 Video, 1 Image, 2 Audios, 3 Resume credits, 3 Resume clips, 15 skills, 10 composite cards </span>
						// 	{ !projectId && <Link to="/">Edit</Link> } 
						// </p>
					}
					</div>
					</div>
				</section>
				{
				this.state.dashboard == 'dashboard-selected' &&
				(<section id="user-dashboard-actions" className="section-user-dashboard-actions gray section">
					<div className="grid-x">
					<div className="small-12 small-centered column text-center">
						<button className="button hollow success disabled" disabled>Change my package</button>
						<button className="button hollow secondary" onClick={this.handleViewProfile}>Update My profile</button>
						{
						!artistInfo.email
						? <button className="button primary disabled" disabled>Continue to Checkin</button>
            : publicToken && client.project
              ? artistRestricted
                ? <a className='button primary' onClick={e => this.setState({showModal: true} )}>Restricted from Submission</a>
                : <Link className="button primary" to={{
  									pathname: `/apply`,
  									search: location.search,
  									state: { 
  										artist: artistInfo, 
  										clientDetails: {
  								  			client: client.companies[0],
  								  			projectId: client.project
  								  		},
  								  		publicArtist: artistInfo,
  								  		projectDetails: client,
  										token: new URLSearchParams(location.search).get('token'),
  										roleList: this.state.role_list
  									}
  								}}>Submit Myself</Link>
							: (client.message || (client.meta && !client.project.allow_new_artist_checkin && this.state.flagForClient))
								? <p></p>
								: projectId
									? client.meta && !client.meta.has_audition 
										? location.state.fromRegistration
											? <Link 
												className="button primary" 
												to={{pathname: `/projects/checkin/${projectId}`, 
													state: {
														artist: location.state.artist,
														clientDetails: {
												  		client: client.companies[0],
												  		projectId: client.project
												  	},
														projectDetails: client,
														hasAudition: false
													}}}>Continue to Checkin</Link>
											: <Link 
												className="button primary" 
												to={{pathname: `/projects/confirmation`, 
													search: `?project=${projectId}`, 
													state: {
														artist: location.state.artist,
														clientDetails: {
												  		client: client.companies[0],
												  		projectId: client.project
												  	},
														projectDetails: client
													}}}>Continue to Checkin</Link>
										: <Link 
												className="button primary" 
												to={{pathname: `${this.state.pathname}`, 
													state: {
														artist: location.state.artist,
														clientDetails: {
												  		client: client.companies[0],
												  		projectId: client.project
												  	},
													}}}>Continue to Checkin</Link>
									: this.state.enableButton ?
										<Link 
											className="button primary" 
											to={{pathname: `${this.state.pathname}`, state: {
													artistInfo: artistInfo
												}}}>Continue to Checkin</Link>
										: <p></p>
						}
					</div>
					</div>


					<Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal} onClose={this.onCloseModal} little>
	          <h2 className="reveal-title">{this.state.errorModalTitle}</h2> 
	          <p>{messaging}</p>
	          <div className="clearfix"></div>
	          <button className="button float-left" onClick={this.onCloseModal}>Close</button>
	        </Modal>
	        <Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal_info} onClose={this.onCloseModal_info} little>
		          <h2 className="reveal-title">SUCCESS</h2> 
		          <p>You have successfully saved your information!</p>
		          <div className="clearfix"></div>
		          <button className="button float-left" onClick={this.onCloseModal_info}>Close</button>
		    	</Modal>

          {artistInfo && publicToken && !artistRestricted ?
            <Modal classNames={{ modal: 'small-modal' }} open={this.state.showModal_reg} onClose={this.onCloseModal_reg} little>
                <h2 className="reveal-title">PROCEED TO REGISTRATION?</h2> 
                <p>You can head straight to registration now!</p>
                <div className="clearfix"></div>
                <button className="button hollow float-left" onClick={this.onCloseModal_reg}>Close</button>&nbsp;&nbsp;
                <Link className="button primary" to={{
                  pathname: `/apply`,
                  search: location.search,
                  state: { 
                    artist: artistInfo, 
                    clientDetails: {
                        client: client.companies[0],
                        projectId: client.project
                      },
                      publicArtist: artistInfo,
                      projectDetails: client,
                    token: new URLSearchParams(location.search).get('token'),
                    roleList: this.state.role_list
                  }
                }}>Submit Myself</Link>
            </Modal> 
            : <span></span>
          }

				</section>)
				}
			</div>
		)
	}
}


// TODO
// get only the props that are needed
const mapStateToProps = state => ({
	...state.auth,
	...state.common,
	...state.artist,
	client: state.client,
	projects: state.projects
	
})
const mapDispatchToProps = (dispatch) => ({
	setCurrentArtist: artist =>
		dispatch({ type: 'SET_ARTIST', payload: { artist } }),
	onLoad: payload =>
		dispatch({type: 'LOAD_DASHBOARD', payload: payload}),
	logoutAritst: () =>
		dispatch({ type: 'LOGOUT' }),
	updateDetails: (id, artist) =>
		dispatch({type: 'UPDATE_ARTIST', payload: agent.Artist.updateDetails(id, artist) })
})
export default connect(mapStateToProps, mapDispatchToProps)(ArtistDashboardContainer)


// WEBPACK FOOTER //
// ./src/containers/ArtistDashboardContainer.js